import React from 'react';
import { Card, CardBody, CardHeader, Col, Table } from 'reactstrap';
import { H5, P } from '../../../AbstractElements';
import { InstallAppUpgradeSystem, RecentActivityTitle } from '../../../Constant';
import { RECENT_ACTIVITY } from '../../../Data/DashBoard/Default/ActivityList';

const constActivityCard = (props) => {
  return (
    <Col xl='3' lg='6' md='7' sm='6' className='box-col-6 our-city'>
      <Card className=' recent-activi'>
        <CardHeader className='pb-0 border-0'>
          <H5>{RecentActivityTitle}</H5>
          <div className='center-content'>
            <P>{InstallAppUpgradeSystem}</P>
          </div>
        </CardHeader>
        <CardBody>
          <div className='table-responsive'>
            <Table className='table-bordernone'>
              <tbody>
                {RECENT_ACTIVITY.map((item, i) => (
                  <tr key={i}>
                    <td>
                      <div className='d-flex'>
                        {item.icon}
                        <div className='flex-grow-1'>
                          <span>{item.title}</span>
                          <P>{item.subTitle}</P>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default constActivityCard;
